import { bulletListCommand } from "./bulletList/bulletList.command";
import { orderedListCommand } from "./orderedList/orderedList.command";
import { IndentCommand } from "./indent/indent.command";
import { OutdentCommand } from "./outdent/outdent.command";
import { QuoteCommand } from "./quotes/quote.comand";
import { headingCommand } from "./heading/heading.command";
import { PickerColorCommand } from "./PickerColor/color-picker.command";

export const customCommands = {
  heading: (editor) => {
    const command = new headingCommand(editor);
    command.execute();
  },
  quote: (editor) => {
    const command = new QuoteCommand(editor);
    command.execute();
  },
  bulletList: (editor) => {
    const command = new bulletListCommand(editor);
    command.execute();
  },

  // Ordered list command
  orderedList: (editor) => {
    const command = new orderedListCommand(editor);
    command.execute();
  },

  //Indent command
  indent: (editor) => {
    const command = new IndentCommand(editor);
    command.execute();
  },

  // Outdent command
  outdent: (editor) => {
    const command = new OutdentCommand(editor);
    command.execute();
  },

  // Text color command
  foreColor: (editor, color) => {
    if (!color) return;
    console.log(`[customCommands] foreColor called with color: ${color}`);
    const command = new PickerColorCommand(editor);
    command.execute(color);
  },
  foreColorVer2: (editor, color) => {
    if (!color) return;
    console.log(`[customCommands] foreColorVer2 called with color: ${color}`);
    const command = new PickerColorCommand(editor);
    command.execute(color);
  }
};
